export default "/images/morsix-light.svg?e9e303c105b7502b8d24e12a4268f7ea";